"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteAudioStatus = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const tool_styles_1 = require("./tool_styles");
const normalize_audio_level_1 = require("../../../../util/normalize_audio_level");
const rxjs_1 = require("../../../../hooks/rxjs");
const room_session_1 = require("../../../../context/room_session");
const RemoteAudioStatus = ({ remoteAudioEnabled = false, }) => {
    const roomSession = (0, room_session_1.useRoomSession)();
    const [remoteAudioLevel] = (0, rxjs_1.useObservable)(roomSession.media.remoteAudio.audioLevel);
    return remoteAudioEnabled ? ((0, jsx_runtime_1.jsx)(tool_styles_1.CallDetailsIcon, { filllevel: (0, normalize_audio_level_1.normalizeAudioLevel)(remoteAudioLevel), name: "MuteIcon", color: ui_react_1.Theme.colors.grey90, "data-testid": "toolbar-mute-icon", style: { transform: 'scale(0.9)' } })) : ((0, jsx_runtime_1.jsx)(tool_styles_1.CallDetailsIcon, { name: "MutedIcon", color: ui_react_1.Theme.colors.red50, slashcolor: ui_react_1.Theme.colors.red50, "data-testid": "toolbar-muted-icon", style: { transform: 'scale(0.9)' } }));
};
exports.RemoteAudioStatus = RemoteAudioStatus;
//# sourceMappingURL=remote_audio_status.js.map